export function findElementByIdDeep(root: Node = document.body, id: string): HTMLElement | null {
  if (!(root instanceof Element || root instanceof Document || root instanceof ShadowRoot)) return null;

  // Direktes Match?
  if ((root as HTMLElement).id === id) {
    return root as HTMLElement;
  }

  for (const child of Array.from(root.children)) {
    // Wenn Shadow Root vorhanden → rekursiv rein
    const shadow = (child as HTMLElement).shadowRoot;
    if (shadow) {
      const found = findElementByIdDeep(shadow, id);
      if (found) return found;
    }

    // Auch normal weitergehen
    const found = findElementByIdDeep(child, id);
    if (found) return found;
  }

  return null;
}
